export default "__VITE_ASSET__DS36jouK__"